/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S7_P2_AInputs */

const tr_mesafeli_s7_p2_a = /** @type {(inputs: Mesafeli_S7_P2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancak Mesafeli Sözleşmeler Yönetmeliği Madde 15/1-h uyarınca,`)
};

const en_mesafeli_s7_p2_a = /** @type {(inputs: Mesafeli_S7_P2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`However, pursuant to Article 15/1-h of the Mesafeli Sözleşmeler Yönetmeliği,`)
};

const de_mesafeli_s7_p2_a = /** @type {(inputs: Mesafeli_S7_P2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemäß Artikel 15/1-h der Mesafeli Sözleşmeler Yönetmeliği gilt jedoch:`)
};

const ru_mesafeli_s7_p2_a = /** @type {(inputs: Mesafeli_S7_P2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Однако согласно статье 15/1-h Mesafeli Sözleşmeler Yönetmeliği,`)
};

/**
* | output |
* | --- |
* | "However, pursuant to Article 15/1-h of the Mesafeli Sözleşmeler Yönetmeliği," |
*
* @param {Mesafeli_S7_P2_AInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s7_p2_a = /** @type {((inputs?: Mesafeli_S7_P2_AInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S7_P2_AInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s7_p2_a(inputs)
	if (locale === "de") return de_mesafeli_s7_p2_a(inputs)
	if (locale === "ru") return ru_mesafeli_s7_p2_a(inputs)
	return tr_mesafeli_s7_p2_a(inputs)
});